(function () {
  'use strict';

  // 番付（地位）の高い順。index が小さいほど上位。
  var RANK_TIERS = [
    '横綱',
    '大関',
    '関脇',
    '小結',
    '前頭',
    '十両',
    '幕下',
    '三段目',
    '序二段',
    '序ノ口',
    '序の口'
  ];

  var KANJI_DIGITS = { 〇: 0, 一: 1, 二: 2, 三: 3, 四: 4, 五: 5, 六: 6, 七: 7, 八: 8, 九: 9 };

  // 「十五」「二十一」などの漢数字を整数へ。失敗時は null。
  function parseKanjiNumber(text) {
    if (!text) return null;
    var hasKanji = /[〇一二三四五六七八九十]/.test(text);
    if (!hasKanji) return null;

    var total = 0;
    var current = 0;
    var matched = false;

    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (ch === '十') {
        total += (current === 0 ? 1 : current) * 10;
        current = 0;
        matched = true;
      } else if (KANJI_DIGITS.hasOwnProperty(ch)) {
        current = KANJI_DIGITS[ch];
        matched = true;
      }
    }
    if (!matched) return null;
    return total + current;
  }

  // 並べ替え用の番付スコア。小さいほど上位。判定不能は Infinity。
  function rankScore(raw) {
    if (raw == null) return Infinity;
    var value = String(raw).trim();
    if (value === '') return Infinity;

    // 数値そのものが入っているケース
    if (/^-?\d+(\.\d+)?$/.test(value)) {
      return parseFloat(value);
    }

    var tier = -1;
    for (var i = 0; i < RANK_TIERS.length; i++) {
      if (value.indexOf(RANK_TIERS[i]) !== -1) {
        tier = i;
        break;
      }
    }
    if (tier === -1) return Infinity;

    // 同地位内の枚数（前頭〇枚目 など）。算用数字・漢数字の両方に対応。
    var num = 0;
    var arabic = value.match(/\d+/);
    if (arabic) {
      num = parseInt(arabic[0], 10);
    } else {
      var kanji = parseKanjiNumber(value);
      if (kanji != null) num = kanji;
    }

    // 東 → 西の順で東を上位に。
    var side = 0;
    if (value.indexOf('東') !== -1) side = 0;
    else if (value.indexOf('西') !== -1) side = 0.5;

    return tier * 1000 + num + side;
  }

  function SumowrestlerCollectionList(root) {
    this.root = root;
    this.grid = root.querySelector('[data-collection-grid]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-collection-item]'));
    this.banzukeFilter = root.querySelector('[data-filter="banzuke"]');
    this.heyaFilter = root.querySelector('[data-filter="heya"]');
    this.sortSelect = root.querySelector('[data-sort-select]');
    this.clearButton = root.querySelector('[data-clear-filters]');
    this.countEl = root.querySelector('[data-results-count]');
    this.emptyEl = root.querySelector('[data-empty-message]');
    this.countTemplate = this.countEl ? this.countEl.getAttribute('data-count-template') || '' : '';
    this.defaultSort = root.getAttribute('data-default-sort') || 'kana';

    this.populateFilter(this.banzukeFilter, 'data-banzuke', true);
    this.populateFilter(this.heyaFilter, 'data-heya', false);

    if (this.sortSelect) {
      var wanted = this.defaultSort;
      var hasOption = Array.prototype.some.call(this.sortSelect.options, function (o) {
        return o.value === wanted;
      });
      if (hasOption) {
        this.sortSelect.value = wanted;
      }
      // 無効な保存値（旧設定など）の場合は最初の選択肢（あいうえお順）を維持し、実値に同期する。
      this.defaultSort = this.sortSelect.value;
    }

    this.bindEvents();
    this.apply();
  }

  SumowrestlerCollectionList.prototype.uniqueValues = function (attr) {
    var seen = {};
    var values = [];
    this.items.forEach(function (item) {
      var v = (item.getAttribute(attr) || '').trim();
      if (v !== '' && !seen[v]) {
        seen[v] = true;
        values.push(v);
      }
    });
    return values;
  };

  SumowrestlerCollectionList.prototype.populateFilter = function (select, attr, isBanzuke) {
    if (!select) return;
    var values = this.uniqueValues(attr);

    if (isBanzuke) {
      values.sort(function (a, b) {
        var diff = rankScore(a) - rankScore(b);
        if (diff !== 0) return diff;
        return a.localeCompare(b, 'ja');
      });
    } else {
      values.sort(function (a, b) {
        return a.localeCompare(b, 'ja');
      });
    }

    var fragment = document.createDocumentFragment();
    values.forEach(function (v) {
      var option = document.createElement('option');
      option.value = v;
      option.textContent = v;
      fragment.appendChild(option);
    });
    select.appendChild(fragment);
  };

  SumowrestlerCollectionList.prototype.bindEvents = function () {
    var self = this;
    var rerun = function () {
      self.apply();
    };
    if (this.banzukeFilter) this.banzukeFilter.addEventListener('change', rerun);
    if (this.heyaFilter) this.heyaFilter.addEventListener('change', rerun);
    if (this.sortSelect) this.sortSelect.addEventListener('change', rerun);
    if (this.clearButton) {
      this.clearButton.addEventListener('click', function () {
        if (self.banzukeFilter) self.banzukeFilter.value = '';
        if (self.heyaFilter) self.heyaFilter.value = '';
        self.apply();
      });
    }
  };

  // フォールバック用：管理画面で並べたブロック順（data-sort-order）。
  function manualOrder(a, b) {
    return (parseInt(a.getAttribute('data-sort-order'), 10) || 0) - (parseInt(b.getAttribute('data-sort-order'), 10) || 0);
  }

  // 比較キー生成関数を受け取り、昇順コンパレータを返す。同値はブロック順。
  function comparatorBy(keyFn, locale, options) {
    return function (a, b) {
      var diff = keyFn(a).localeCompare(keyFn(b), locale, options);
      return diff !== 0 ? diff : manualOrder(a, b);
    };
  }

  function attr(el, name) {
    return (el.getAttribute(name) || '').trim();
  }

  SumowrestlerCollectionList.prototype.comparator = function (mode) {
    if (mode === 'alphabet') {
      // アルファベット順 = メタフィールド custom.alphabet。空ならハンドル（ローマ字）。
      return comparatorBy(function (el) {
        return attr(el, 'data-alphabet') || attr(el, 'data-handle');
      }, 'en', { numeric: true, sensitivity: 'base' });
    }
    // kana（デフォルト）= あいうえお順 = スキーマ（ブロック）の登録順。言語に依存しない。
    return manualOrder;
  };

  SumowrestlerCollectionList.prototype.apply = function () {
    var banzukeValue = this.banzukeFilter ? this.banzukeFilter.value : '';
    var heyaValue = this.heyaFilter ? this.heyaFilter.value : '';
    var sortMode = this.sortSelect ? this.sortSelect.value : this.defaultSort;

    var visibleCount = 0;
    this.items.forEach(function (item) {
      var matchBanzuke = banzukeValue === '' || (item.getAttribute('data-banzuke') || '').trim() === banzukeValue;
      var matchHeya = heyaValue === '' || (item.getAttribute('data-heya') || '').trim() === heyaValue;
      var visible = matchBanzuke && matchHeya;
      item.hidden = !visible;
      if (visible) visibleCount++;
    });

    var sorted = this.items.slice().sort(this.comparator(sortMode));
    if (this.grid) {
      var fragment = document.createDocumentFragment();
      sorted.forEach(function (item) {
        fragment.appendChild(item);
      });
      this.grid.appendChild(fragment);
    }

    if (this.countEl) {
      this.countEl.textContent = this.countTemplate.replace('{count}', visibleCount);
    }
    if (this.emptyEl) {
      this.emptyEl.hidden = visibleCount !== 0;
    }
    if (this.clearButton) {
      this.clearButton.hidden = banzukeValue === '' && heyaValue === '';
    }
  };

  function init(container) {
    var roots = (container || document).querySelectorAll('.collection-list-sumowrestler[data-section-id]');
    roots.forEach(function (root) {
      if (root.dataset.sumowrestlerInit === 'true') return;
      root.dataset.sumowrestlerInit = 'true';
      new SumowrestlerCollectionList(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // テーマエディタでセクションを再読み込みした際に再初期化する。
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
